<template>
    <full-overlay width="100%" max-width="480px" :background-color="backgroundColor">
        <transition name="bounce">
            <div v-if="show" class="ding-popup-wrapper">
                <div class="content-row">
                    <div v-if="iconUrl" class="icon" :style="iconStyle"></div>
                    <div v-if="title" class="title">{{title}}</div>
                    <div v-if="mode === 'loading'" class="loading">
                        <loading-indicator :full-parent="false" :isLoading="true" :clearBackground="true"></loading-indicator>
                    </div>
                    <div v-if="message" cy-popup-message class="message" v-html="message"></div>
                    <div v-if="mode === 'prompt'">
                        <p class="text-danger" v-if="showInputRequired">{{$t('input_is_required')}}</p>
                        <input ref="input" type="text" class="form-control" v-model="userInput" :placeholder="placeholder" />
                    </div>
                </div>
                <div class="button-row" v-if="mode !== 'loading'">
                    <div v-if="mode === 'confirm' || mode === 'prompt'">
                        <button cy-popup-confirm class="btn btn-sm" :class="'btn btn-sm ' + confirmButtonClass" @click="confirm">{{confirmText || $t('confirm')}}</button>
                        <button cy-popup-cancel class="btn btn-sm btn-secondary" @click="close('cancel')">{{cancelText || $t('cancel')}}</button>
                    </div>
                    <div v-if="mode === 'alert'">
                        <button cy-popup-close class="btn btn-sm btn-primary" @click="close('close')">{{closeText || $t('close')}}</button>
                    </div>
                </div>
            </div>
        </transition>
    </full-overlay>
</template>

<i18n>
{
    "en": {
       "input_is_required": "Please enter content",
       "confirm": "Confirm",
       "cancel": "Cancel",
       "close": "Close"
    },
    "zh": {
       "input_is_required": "請輸入文字",
       "confirm": "確認",
       "cancel": "取消 ",
       "close": "關閉"
    }
}
</i18n>

<script>
import FullOverlay from './FullOverlay';
import LoadingIndicator from './LoadingIndicator';

export default {
    props: {
        // can be `prompt`, `confirm`, `alert` or `loading`
        mode: {
            type: String,
            required: true
        },
        title: String,
        message: String,
        iconUrl: String,
        cancelText: String,
        confirmText: String,
        closeText: String,
        backgroundColor: {
            type: String,
            required: false,
            default: 'rgba(0, 0, 0, 0.1)'
        },
        confirmButtonClass: {
            type: String,
            default: 'btn-primary'
        },
        inputRequired: {
            type: Boolean,
            default: true
        },
        placeholder: {
            type: String,
            default: ''
        }
    },
    components: {
        FullOverlay, LoadingIndicator
    },
    mounted() {
        this.show = true;
        this.$i18n.locale = this.getLang();

        if (this.mode === 'prompt') {
            this.$nextTick(() => {
                this.$refs['input'].focus();
            });
        }
    },
    computed: {
        iconStyle() {
            return {
                backgroundImage: 'url("' + this.iconUrl + '")'
            };
        }
    },
    methods: {
        getLang() {
            return window.document.querySelector('meta[name="lang"]').attributes.content.value;
        },
        close(action) {
            this.show = false;
            this.$emit(action);
        },
        getUserInput() {
            return this.userInput;
        },
        confirm() {
            if (this.mode === 'prompt' && this.inputRequired && this.userInput.length == 0) {
                this.showInputRequired = true;
                return;
            }

            this.$emit('confirm', this.userInput);
        }
    },
    data() {
        return {
            show: false,
            userInput: "",
            showInputRequired: false
        }
    }
}
</script>

<style scoped>
    .ding-popup-wrapper {
        max-width: 360px;
        text-align: center;
        background: white;
        margin: 0 auto;
        border-radius: 4px;
        padding: 10px 20px 0px;
        font-size: 14px;
        color: #31393C;
        min-width: 180px;
        box-shadow: 0px 0px 12px rgba(0,0,0, 0.3);
    }

    .content-row {
        padding-left: 12px;
        padding-right: 12px;
    }

    .title {
        font-size: 16px;
        margin-top: 8px;
        margin-bottom: 16px;
        font-weight: bolder;
    }

    .icon {
        width: 30px;
        height: 30px;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        margin: 8px auto;
    }

    .message {
        margin: 8px auto 15px;;
        white-space: pre-line;
        word-break: break-word;
    }

    .loading {
        position: relative;
        width: 40px;
        height: 40px;
        margin: 0 auto 10px;
    }

    .button-row {
        margin: 1em auto 1em;
    }
</style>
